import styled from "styled-components";
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  height: 100vh;
  align-items: center;
  padding: 0px 20px;
  .container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    margin-top: 10%;
    gap: 20px;
    p {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }
  }
`;
